import { ManualRosteringRouting } from "./manual-rostering/manual-rostering.routing";
import { RosteringOldComponent } from "./rostering-old.component";
import { RouteRouting } from "./routes/routes.routing";

export const RosteringOldRouting = [
    { path: '', redirectTo: 'rostering', pathMatch: 'full' },
    { path: 'rostering', component: RosteringOldComponent },
    { path: 'manual', children: ManualRosteringRouting },
    { path: 'routes', children: RouteRouting },
];
